import * as React from 'react';

const BellNotificationChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.54 6l.993.008c3.784.302 6.474 3.556 6.474 7.97l.029 4.018H20v2.012h-6.07A1.993 1.993 0 0111.944 22a1.993 1.993 0 01-1.986-2v.007H4v-2.01h.947L4.92 13.98c0-4.477 2.761-7.758 6.621-7.98zm.417 1.978c-3.503 0-4.976 3.332-4.976 5.892l.028 4.147 9.945-.002-.029-4.143c0-2.562-1.458-5.894-4.968-5.894zM14 5h-4V3h4v2z"
            fill="#4B4D63"
        />
    </svg>
);

BellNotificationChunkySvg.displayName = 'BellNotificationChunkySvg';
export default BellNotificationChunkySvg;
